import React from 'react';
import {
 Badge
} from 'shared/components/ui/badge';

type Counts = {
    steps: number;
    defs: number;
    flows: number;
};

type JsonHeaderProps = {
    isValid: boolean;
    validationMessage: string;
    counts: Counts;
};

const JsonHeader = ({
    isValid,
    validationMessage,
    counts
}: JsonHeaderProps) => (
    <div className="flex items-center gap-3 flex-wrap">
        <Badge className="flex items-center gap-2" variant="secondary">
            <span className={`w-2.5 h-2.5 rounded-full ${isValid ? 'bg-emerald-500' : 'bg-rose-500'}`} />
            {isValid ? validationMessage : 'Invalid JSON'}
        </Badge>
        <Badge className="flex items-center gap-1" variant="secondary">Steps: {counts.steps}</Badge>
        <Badge className="flex items-center gap-1" variant="secondary">Definitions: {counts.defs}</Badge>
        <Badge className="flex items-center gap-1" variant="secondary">Flows: {counts.flows}</Badge>
    </div>
);

export default JsonHeader;
